import type { EditControlProps } from '../../declare'
import { useState, useEffect } from 'react'
import { autorun } from 'mobx'
import { Select } from 'antd'
import { appStore } from 'src/stores'

const EnumSelect = (props: EditControlProps) => {
  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const { __CONTEXT__: editTable } = props.config
    const find = editTable.activeTableConfig?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM, data))
      })
    }
  }), [props.config.ENUM])

  const { __READONLY__, EDITABLE } = props.config
  return (
    <Select
      allowClear
      disabled={__READONLY__ || !EDITABLE}
      value={props.value !== undefined ? Number(props.value) : props.value}
      options={options}
      onChange={handleChange}
    />
  )
}

export default EnumSelect